export const Settings = {
  appVersion: '1.0'
};
